export enum PAYMENTS_CHOICES {
  PAGO_EN_ORIGEN = 1,
  PAGO_EN_DESTINO = 2,
}

export const PaymentsChoicesString = {
  [PAYMENTS_CHOICES.PAGO_EN_ORIGEN]: 'Pago en origen',
  [PAYMENTS_CHOICES.PAGO_EN_DESTINO]: 'Pago en destino',
};
